// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_GatewayToggleResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_GatewayToggleResponse — response for POST /subscriptions/gateways/toggle.
 *
 * Returns the updated full enablement map after the toggle write, using the
 * same features shape as Subscriptions_GatewayMapResponse so the caller has a
 * fresh consistent view without a second GET.
 *
 * Shape (identical to GET /subscriptions/gateways/map dados):
 * {
 *   "features": {
 *     "<feature>": {
 *       "<provider_code>": {
 *         "enabled": bool,
 *         "capabilities": { "<op>": bool, ... }
 *       },
 *       ...
 *     },
 *     ...
 *   }
 * }
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_GatewayToggleResponseDados {
features: Record<string, Record<string, {
enabled: boolean,
capabilities: Record<string, boolean>,
}>>
}

export type Subscriptions_GatewayToggleResponse = ApiResponse<Subscriptions_GatewayToggleResponseDados>;

registerResponseContract('Subscriptions_GatewayToggleResponse', {
  features: { type: 'object',  required: true },
})
